module.exports = __webpack_public_path__ + "static/media/22770819_1629541480454370_7658714337510599546_o.ae8052af.jpg";